<template>
<section class="box-boloes-series card lot-bg-dark" v-bind:class="[{'is-loaded' : loaded }]">
  <div class="box-boloes-series__loader"></div>
  <div class="box-boloes-series__content">
    <div class="box-boloes-series__name d-none d-lg-block" v-if="products">
      <div class="box-boloes-series__name__label">Bolão</div>
      <div class="box-boloes-series__name__value" v-text="products.name"></div>
    </div>

    <div class="box-boloes-series__prize d-none d-lg-flex" v-if="products && products.drawInfo">
      <div class="box-boloes-series__prize__label">Prêmio</div>
      <div class="box-boloes-series__prize__value" v-text="products.drawInfo.estimatedPrize > 0 ? 'R$ '+products.drawInfo.estimatedPrizeText : products.drawInfo.estimatedPrizeText"></div>
      <div class="box-boloes-series__prize__is-jackpot" v-if="products.drawInfo.isJackpot">
        <i class="fa fa-star"></i>
        <span>Acumulada!</span>
      </div>
    </div>

    <div class="box-boloes-series__options" v-if="products && products.items.length">
      <div class="box-boloes-series__options__title">
        <span>Opção de Jogo</span>
        <button class="btn-info btn-info--white ml-1" v-on:click="scrollToOptions()"><i class="fa fa-question"></i></button>
      </div>
      <div class="box-boloes-series__options__items">
        <button v-for="item,index in products.items" :key="`box-boloes-series__options__items-${index}`" v-text="item.serie" v-on:click="selectItem(index)" v-bind:class="{'lot-bg-light' : selectedItemIndex === index}"></button>
      </div>
    </div>

    <div v-if="selectedItem" class="box-boloes-series__jogo__buy-head">
      <div class="text-left">
        <strong v-text="selectedItem.unitsInStock || 0"></strong> /
        <span v-text="selectedItem.units || 0"></span> Cotas disponíveis
      </div>
      <div class="text-right">
        <i class="fa fa-refresh fa-spin" v-if="processing"></i>
        <strong
          v-text="intToReal(selectedItem.myUnits * selectedItem.unitPrice)"
        ></strong>
      </div>
    </div>

    <div v-if="selectedItem" class="box-boloes-series__jogo__buy-qty">
      <div class="box-boloes-series__jogo__qty__control">
        <button v-on:click="setUnits(selectedItemIndex, '-')">
          <span>-</span>
        </button>
        <input
          type="tel"
          value="0"
          maxlength="4"
          :key="selectedItem.itemName"
          v-model="selectedItem.myUnits"
          v-on:keyup.enter="setUnits(selectedItemIndex, selectedItem.myUnits, true)"
          v-on:blur="setUnits(selectedItemIndex, selectedItem.myUnits)"
        />
        <button v-on:click="setUnits(selectedItemIndex, '+')">
          <span>+</span>
        </button>
      </div>
      <button
        class="box-boloes-series__jogo__btn-add"
        v-on:click="setUnits(selectedItemIndex, '+', true)"
        :disabled="processing"
      >
        Comprar
      </button>
    </div>

  </div>
</section>
</template>
<style src="./BoxBoloesSeries.scss" scoped></style>
<script>
import intToReal from '@helpers/intToReal';

export default {
  data: function () {
    return {
    };
  },
  emits: ['setunits', 'selectitem'],
  props: {
    products: null,
    selectedItemIndex: Number
  },
  methods: {
    intToReal,
    setUnits (itemIndex, newUnits, isImmediately = false) {
      this.$emit('setunits', {
        itemIndex,
        newUnits,
        isImmediately
      })
    },
    selectItem (itemIndex) {
      this.$emit('selectitem', itemIndex)
    },
    scrollToOptions () {
      this.$scrollTo(document.getElementById('opcoes'))
    }
  },
  computed: {
    loaded () {
      return !!this.products;
    },
    selectedItem () {
      if (!this.products) { return null; }
      return this.products.items[this.selectedItemIndex] || null;
    }
  }
}
</script>
